import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
export const MonetizationStrip = ({ className , deviation  })=>{
    var _deviation_extended;
    const { t  } = useTranslation();
    const promo = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.showStageMonetizationPromo;
    if (!promo || ![
        'tier',
        'commission'
    ].includes(promo) || !deviation.author) {
        return null;
    }
    const biData = {
        evid: promo === 'tier' ? BiEventType.VIEW_SUBSCRIPTION_TAB : BiEventType.VIEW_COMMISSIONS_TAB,
        typeid: deviation.typeId,
        itemid: deviation.deviationId,
        referral_info: ReferralType.ART_STAGE_PROMOTION
    };
    return /*#__PURE__*/ React.createElement(PromoBanner, {
        className: className,
        size: "small",
        variant: "subscription",
        icon: /*#__PURE__*/ React.createElement(PromoBadge, {
            badgeType: promo,
            size: 16
        }),
        messageAfterIcon: t(`deviationview.artstage.monetizationStrip.var.${promo}.body`),
        ctaLabel: t(`deviationview.artstage.monetizationStrip.var.${promo}.CTA`),
        ctaHref: promo === 'tier' ? Url.userSubscriptionsPath({
            username: deviation.author.username
        }) : Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS),
        ctaBiData: biData
    });
};
MonetizationStrip.displayName = 'MonetizationStrip';
export default MonetizationStrip;
